import Vue from 'vue';
import App from './App';
import router from '@/router';
/*************** vuex**************/
import store from '@/store';
/************* axios ************/
import axios from '@/api/request';
Vue.prototype.$axios = axios;


/**************注册全局过滤器*************/
import * as filters from '@/extension/filters';
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});

/***************注册指令*******************/
import dialogDrag from '@/extension/directive/drag/index';
Vue.use(dialogDrag);
import perm from '@/extension/directive/perm/index';
Vue.directive('perm', perm);
/************* 拦截控制 ****************/
import '@/extension/interceptor/route'; // permission control

/************  引入echarts *************/
import echarts from 'echarts';
Vue.prototype.$echarts = echarts;

/*********** svg注冊**************/
import '@/assets/icons';

/*************** ant-design-vue ************/
import Antd, { notification } from 'ant-design-vue/es';
Vue.use(Antd);
import 'ant-design-vue/dist/antd.css';

Vue.component('AButton').mixin({
  data() {
    return {
      debounce: false,
    };
  },
  methods: {
    handleClick(evt) {
      if (this.debounce) {
        notification.info({
          message: '警告',
          description: '按钮点击间隔不得低于一秒',
        });
      } else {
        this.debounce = true;
        this.$emit('click', evt);
        setTimeout(() => {
          this.debounce = false;
        }, 100); // 延时时间
      }
    },
  },
});
/************生产提示:根据自己需求决定是否放开**************/
Vue.config.productionTip = false;
window.rad = 0;
/************ 全局注册lodash ***************/
import _ from 'lodash';
Vue.prototype._ = _;

// 加载插件
const Plugins = require.context('@/plugins', true, /\.js$/)
Plugins.keys().map(Plugins)

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
